import PropTypes from 'prop-types';

import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import { default as styles } from '../../../scss/components/Card.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface CardCopyProps {
  text?: string;
  fontSizeClassName?: string;
}

const CardCopy = ({ text, fontSizeClassName }: CardCopyProps) => {
  if (!text?.length) {
    return null;
  }

  return (
    <div className={withCssModulesClassNamesHandler('card__copy')}>
      <p className={withCssModulesClassNamesHandler(fontSizeClassName)}>{text}</p>
    </div>
  );
};

CardCopy.defaultProps = {
  text: '',
  fontSizeClassName: '',
};

CardCopy.propTypes = {
  text: PropTypes.string,
  fontSizeClassName: PropTypes.string,
};

export default CardCopy;
